import { useQueryClient } from 'react-query';
import Profile from './profile';
import ProfileSkeleton from './profileSkeleton';
import Support from './support';
import UserProfile from './userProfile';
import { IGetCustomerInfoResponse } from '../../../models/customer.model';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';


const MenuContainer = ({ setTabChild }: { setTabChild: any }) => {
    const navigate = useNavigate();
    const queryClient = useQueryClient()
    const { profile, isLoading }: { profile: IGetCustomerInfoResponse; isLoading: boolean } = queryClient.getQueryData('PROFILE_INFO')! || {}
    const setState = (state: 'profile' | 'support' | 'userProfile') => navigate(`/account/${state === 'profile' ? '' : state}`);
    if (isLoading) {
        return (
            <ProfileSkeleton />
        )
    }
    return (
        <Routes>
            <Route index element={<Profile setState={setState} setTabChild={setTabChild} profile={profile!} />} />
            <Route path="support" element={<Support />} />
            <Route path="userProfile" element={<UserProfile profile={profile!} />} />
            <Route path="*" element={<Navigate to="/account" replace />} />
        </Routes>
    )
}

export default MenuContainer
